import { post } from './fetch';

const apiOrderTogglePickedUp = async ( orderId, completed, dispatch ) => {
    await post( 'apiOrderWasPickedUp', '/api/order/toggle-picked-up',
        { orderId }, completed, dispatch
    );
}

export default apiOrderTogglePickedUp;